import React from 'react';
import SequencerDataTable from '../components/SequencerDataTable';

function Sequencers() {
  return (
    <div>
      <h1> </h1>
      {/* Your nodes content here */}
      <SequencerDataTable/>
    </div>
  );
}

export default Sequencers;
